import {
  GET_MATCH_GROUPS,
  GET_MATCH_GROUP,
  ADD_MATCH_GROUP,
  UPDATE_MATCH_GROUP,
  DELETE_MATCH_GROUP,
  ADD_MATCHES_TO_GROUP,
  REMOVE_MATCHES_FROM_GROUP,
  MATCH_GROUP_ERROR,
  CLEAR_MATCH_GROUPS,
  SET_LOADING
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_MATCH_GROUPS:
      return {
        ...state,
        matchGroups: action.payload,
        loading: false
      };
    case GET_MATCH_GROUP:
      return {
        ...state,
        currentGroup: action.payload,
        loading: false
      };
    case ADD_MATCH_GROUP:
      return {
        ...state,
        matchGroups: [action.payload, ...state.matchGroups],
        loading: false
      };
    case UPDATE_MATCH_GROUP:
      return {
        ...state,
        matchGroups: state.matchGroups.map(group =>
          group._id === action.payload._id ? action.payload : group
        ),
        currentGroup: state.currentGroup?._id === action.payload._id 
          ? action.payload 
          : state.currentGroup,
        loading: false
      };
    case DELETE_MATCH_GROUP:
      return {
        ...state,
        matchGroups: state.matchGroups.filter(
          group => group._id !== action.payload
        ),
        currentGroup: state.currentGroup?._id === action.payload 
          ? null 
          : state.currentGroup,
        loading: false
      };
    case ADD_MATCHES_TO_GROUP:
      return {
        ...state,
        currentGroup: action.payload,
        loading: false
      };
    case REMOVE_MATCHES_FROM_GROUP:
      return {
        ...state,
        currentGroup: action.payload,
        loading: false
      };
    case MATCH_GROUP_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case CLEAR_MATCH_GROUPS:
      return {
        ...state,
        matchGroups: [],
        currentGroup: null,
        loading: false
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
};